import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {UserService} from '../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {apiEndpoints} from '../app.constants';
import {BlockedReason, InvalidAction, WallType} from '../../models/user';
import {EventTrackerService, Page, UserActionType} from '../services/event-tracker/event-tracker.service';
import { filter, concatMap } from 'rxjs/operators';


@Injectable()
export class LevelsGuard implements CanActivate, CanActivateChild {
  constructor(private userService: UserService,
              private translate: TranslateService,
              private eventTracker: EventTrackerService,
              private router: Router) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Admin always have permission
    if (this.userService.isAdmin || this.userService.isInfluencer) {
      return true;
    }
    const { levels } = route.data;
    const currentLevel = this.userService.accountType();

    if (currentLevel) {
      const hasValidLevel = Array.isArray(levels) && levels.indexOf(currentLevel) >= 0;
      if (!hasValidLevel) {
        this.userService.doInvalidActionByLevel('Invalid Access',
          this.translate.instant('common.invalid_action_by_levels_warning.common_msg'));
        this.sendInvalidActionToSegement();
      }
      return hasValidLevel;
    } else {
      // get company if ready,
      // otherwise, waiting for it being set in userService
      const companyId = this.userService.getCompanyId();

      if (!companyId) {
        return this.userService.companyId
          .pipe(
            filter(x => !!x),
            concatMap((x) => this.callApiToCheckLevel(x, levels))
          );
      }

      return this.callApiToCheckLevel(companyId, levels);
    }
  }

  private callApiToCheckLevel(companyId: number, levels): Observable<boolean> {
    return this.userService.getAccountLevels(companyId).map(res => {
      const isValidLevel = res && res.level && Array.isArray(levels) && levels.indexOf(res.level.name) >= 0;
      if (!isValidLevel) {
        this.userService.doInvalidActionByLevel('Invalid Access',
          this.translate.instant('common.invalid_action_by_levels_warning.common_msg'));
        this.sendInvalidActionToSegement();
        return false;
      }
      return true;
    });
  }

  private sendInvalidActionToSegement() {
    const detailAction = new InvalidAction(true, BlockedReason.ACCOUNT_WALL, WallType.FEATURE_UNAVAILABLE,
      'Campaigns Disabled', false, null, null, this.userService.accountLevelName);
    this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.VIEW, Page.CAMPAIGN_TAB);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/levels.guard.ts